<template>
  <div class="space-y-3">
    <PrimeFloatLabel variant="on">
      <PrimePassword
        id="password"
        v-model="password"
        :toggle-mask="true"
        input-class="w-full"
        :invalid="!isValid && password.length > 0"
        :promptLabel="$t('components.auth.passwordPromptLabel')"
        class="w-full"
        required
        :pt="{
          input: { class: 'w-full' },
          showIcon: { class: 'right-2' },
          hideIcon: { class: 'right-2' },
        }"
        @input="checkPasswordStrength"
        @blur="validatePasswords"
      >
        <template #footer>
          <PrimeDivider />
          <ul class="space-y-2">
            <li
              v-for="(hint, key) in hints"
              :key="key"
              class="flex items-center gap-2"
            >
              <span class="shrink-0">
                <i v-if="hint.value" class="pi pi-check text-green-500" />
                <i v-else class="pi pi-times text-red-500" />
              </span>
              <span
                :class="{
                  'text-green-500': hint.value,
                  'text-red-500': !hint.value,
                }"
              >
                {{ $t(`components.auth.createPasswordHints.${hint.url}`) }}
              </span>
            </li>
          </ul>
        </template>
      </PrimePassword>

      <label for="password" class="flex items-center">{{ $t('components.auth.password') }}</label>
    </PrimeFloatLabel>

    <PrimeFloatLabel variant="on">
      <PrimePassword
        id="confirm_password"
        v-model="confirm_password"
        :feedback="false"
        :toggle-mask="true"
        input-class="w-full"
        class="w-full"
        :invalid="confirm_password !== password && confirm_password.length > 0"
        required
        :pt="{
          input: { class: 'w-full' },
          showIcon: { class: 'right-2' },
          hideIcon: { class: 'right-2' },
        }"
        @input="validatePasswords"
      />
      <label for="confirm_password" class="flex items-center">{{ $t('components.auth.confirmPassword') }}</label>
    </PrimeFloatLabel>
    <!-- <Message v-if="!email" severity="error" variant="simple" size="small">Email is not valid</Message> -->
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'PasswordInput',
  emits: ['password-created'],

  data() {
    return {
      password: '',
      confirm_password: '',
      isValid: false,
      hints: {
        minLength: {
          url: 'minLength',
          value: false,
        },
        lowercase: {
          url: 'lowercase',
          value: false,
        },
        uppercase: {
          url: 'uppercase',
          value: false,
        },
        numbers: {
          url: 'numbers',
          value: false,
        },
        specialChars: {
          url: 'specialChars',
          value: false,
        },
      },
    };
  },
  methods: {
    checkPasswordStrength() {
      this.hintsVisible = !!this.password;
      this.hints.minLength.value = this.password.length >= 6;
      this.hints.lowercase.value = /[a-z]/.test(this.password);
      this.hints.uppercase.value = /[A-Z]/.test(this.password);
      this.hints.numbers.value = /\d/.test(this.password);
      this.hints.specialChars.value = /[!@#$%^&*(),.?":{}|<>]/.test(
        this.password
      );
    },
    validatePasswords() {
      this.isValid = Object.values(this.hints).every(hint => hint.value);

      if (this.isValid && this.password === this.confirm_password) {
        this.$emit('password-created', this.password);
      } else {
        this.$emit('password-created', null);
      }
    },
  },
});
</script>
